import { render, staticRenderFns } from "./PrincipalDashboard.vue?vue&type=template&id=e07267bc&scoped=true&"
import script from "./PrincipalDashboard.ts?vue&type=script&lang=ts&"
export * from "./PrincipalDashboard.ts?vue&type=script&lang=ts&"
import style0 from "./PrincipalDashboard.scss?vue&type=style&index=0&id=e07267bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e07267bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VContainer,VImg})
